import { createParser, parseAsArrayOf, parseAsString } from 'nuqs'
import { z } from 'zod'

import type { FilterValue } from 'components/Filter'
import type { SingleParserBuilder } from 'nuqs'

const positiveIntegerCodec: z.ZodCodec<z.ZodString, z.ZodNumber> = z.codec(
  z.string(),
  z.number().int().positive(),
  {
    decode: (value: string): number => Number(value),
    encode: (value: number): string => String(value),
  },
)

const filtersParser: SingleParserBuilder<string[]> = parseAsArrayOf(parseAsString)
const filtersSchema: z.ZodArray<z.ZodString> = z.array(z.string())

export const parseAsFilters = createParser<FilterValue[]>({
  eq: (a: FilterValue[], b: FilterValue[]): boolean => filtersParser.eq(a, b),
  parse: (value: string): FilterValue[] | null => {
    const parsedValue: null | string[] = filtersParser.parse(value)
    const validationResult: z.ZodSafeParseResult<string[]> = filtersSchema.safeParse(parsedValue)

    return validationResult.success ? validationResult.data : null
  },
  serialize: (value: FilterValue[]): string => filtersParser.serialize(filtersSchema.parse(value)),
})

export const parseAsPositiveInteger = createParser<number>({
  parse: (value: string): null | number => {
    const validationResult: z.ZodSafeParseResult<number> = positiveIntegerCodec.safeParse(value)

    return validationResult.success ? validationResult.data : null
  },
  serialize: (value: number): string => positiveIntegerCodec.encode(value),
})
